export default __webpack_public_path__ + "static/media/1280x500_wakeup05.f105057b.jpg";